import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { motion } from 'framer-motion';
import { API_BASE_URL } from '../../../apiConfig';
import useBreakpoint from '../../../hooks/useBreakpoint';

export default function HomeDivisions() {
    const [divisions, setDivisions] = useState([]);
    const { isDesktop } = useBreakpoint();

    useEffect(() => {
        let isMounted = true;
        axios.get(`${API_BASE_URL}/currentDivision`)
            .then(res => {
                if (isMounted) setDivisions(res.data);
            })
            .catch(err => console.error("Error fetching divisions for home:", err));
        return () => { isMounted = false; };
    }, []);

    if (divisions.length === 0) return null;

    return (
        <section style={{ 
            padding: isDesktop ? '100px 0' : '60px 0',
            background: 'transparent',
            position: 'relative'
        }}>
            <div style={{ maxWidth: 'var(--maxWidth)', margin: '0 auto', padding: '0 24px' }}>
                
                {/* Header */}
                <div style={{ marginBottom: isDesktop ? '60px' : '40px', textAlign: 'center' }}>
                    <h2 style={{
                        fontFamily: 'var(--fontDisplay)',
                        fontSize: isDesktop ? '48px' : '32px',
                        fontWeight: 900,
                        color: 'var(--blue)',
                        textTransform: 'uppercase',
                        letterSpacing: '-1px',
                        margin: '0 0 10px 0',
                        lineHeight: 1
                    }}>
                        Official Divisions
                    </h2>
                    <div style={{ 
                        width: '60px', 
                        height: '4px', 
                        background: 'var(--yellow)', 
                        margin: '0 auto',
                        borderRadius: '2px'
                    }} />
                    <p style={{
                        marginTop: '15px',
                        fontFamily: 'var(--fontBody)',
                        fontSize: '14px',
                        color: 'rgba(0,0,0,0.6)',
                        textTransform: 'uppercase',
                        fontWeight: 700,
                        letterSpacing: '1px'
                    }}>
                        Explore the hierarchy of the British Tamils Cricket League
                    </p>
                </div>

                {/* Grid */}
                <div style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    justifyContent: 'center',
                    gap: isDesktop ? '24px' : '20px'
                }}>
                    {divisions.map((division, index) => (
                        <motion.div
                            key={division.PCID}
                            initial={{ opacity: 0, scale: 0.9, y: 30 }}
                            whileInView={{ 
                                opacity: 1, 
                                scale: 1, 
                                y: 0,
                                transition: { 
                                    duration: 0.6,
                                    delay: index * 0.1,
                                    ease: [0.215, 0.610, 0.355, 1.000] // Premium cubic-bezier
                                }
                            }}
                            viewport={{ once: true, margin: "-50px" }}
                            style={{
                                width: isDesktop ? 'calc(25% - 18px)' : '100%',
                                minWidth: isDesktop ? '260px' : 'auto'
                            }}
                        >
                            <Link
                                to={`/leagues`}
                                onClick={() => window.scrollTo(0, 0)}
                                style={{ textDecoration: 'none' }}
                            >
                                <motion.div
                                    whileHover={{ y: -8, boxShadow: '0 20px 40px rgba(0,4,67,0.4)' }}
                                    style={{
                                        background: 'linear-gradient(180deg, #0812BB 0%, #000443 100%)',
                                        padding: '25px 20px',
                                        borderRadius: '8px',
                                        textAlign: 'center',
                                        color: '#ffffff',
                                        boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
                                        transition: 'all 0.3s ease',
                                        minHeight: '100px',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        gap: '8px'
                                    }}
                                >
                                    <span style={{
                                        fontFamily: 'var(--fontDisplay)',
                                        fontSize: '20px',
                                        fontWeight: 800,
                                        textTransform: 'uppercase',
                                        letterSpacing: '1px',
                                        lineHeight: 1.2
                                    }}>
                                        {division.name}
                                    </span>
                                    <span style={{
                                        fontSize: '10px',
                                        fontWeight: 700,
                                        color: 'var(--yellow)',
                                        textTransform: 'uppercase',
                                        letterSpacing: '2px',
                                        opacity: 0.9
                                    }}>
                                        View League Details
                                    </span>
                                </motion.div>
                            </Link>
                        </motion.div>
                    ))}
                </div>

                {/* View All Button */}
                <div style={{ marginTop: '50px', textAlign: 'center' }}>
                    <Link 
                        to="/leagues" 
                        style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '10px',
                            padding: '14px 32px',
                            background: 'var(--blue)',
                            color: '#fff',
                            textDecoration: 'none',
                            borderRadius: '4px',
                            fontWeight: 700,
                            textTransform: 'uppercase',
                            fontSize: '13px',
                            letterSpacing: '1px',
                            boxShadow: '0 4px 15px rgba(4,9,96,0.2)'
                        }}
                    >
                        View All Divisions
                        <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M5 12h14M12 5l7 7-7 7" /></svg>
                    </Link>
                </div>
            </div>
        </section>
    );
}
